'use client';

import React from 'react';
import ContactMethodSelector from './ContactMethodSelector';
import SectionLabel from '../home/SectionLabel';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';

type Props = {
  lang: Locale;
};

const Section1 = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <>
      <section
        aria-label={t('ContactUs/V3/Hero/aria_label')}
        className="relative px-6 pt-24 pb-20 lg:pt-32 lg:pb-24 overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, #0A0E27 0%, #1B1238 100%)',
          color: '#F5F7FA',
        }}
      >
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '50%',
            right: '-160px',
            width: 560,
            height: 560,
            transform: 'translateY(-50%)',
            background: 'radial-gradient(circle, rgba(34,211,238,0.16) 0%, transparent 60%)',
            pointerEvents: 'none',
          }}
        />

        <div className="relative mx-auto max-w-[1200px]">
          <SectionLabel num="01" label={t('ContactUs/V3/Hero/label')} />

          <h1
            className="font-bold tracking-tight"
            style={{
              fontSize: 'clamp(32px, 5.6vw, 64px)',
              lineHeight: 1.08,
              letterSpacing: '-0.02em',
              color: '#F5F7FA',
              margin: '14px 0 0',
              maxWidth: 880,
            }}
          >
            <span className="block">{t('ContactUs/V3/Hero/headline_a')}</span>
            <span className="block" style={{ color: '#B4C1D8' }}>
              {t('ContactUs/V3/Hero/headline_b')}
            </span>
          </h1>

          <p
            style={{
              fontSize: 'clamp(16px, 1.6vw, 20px)',
              lineHeight: 1.5,
              color: '#B4C1D8',
              margin: '20px 0 0',
              maxWidth: 720,
            }}
          >
            {t('ContactUs/V3/Hero/subhead')}
          </p>
        </div>
      </section>

      <ContactMethodSelector lang={lang} />
    </>
  );
};

export default Section1;
